<template>
  <Dialog
    :close-on-escape="true"
    :show-dialog="showDialog"
    @close="handleClose"
  >
    <Card
      class="tw-w-full lg:tw-w-96"
      :has-body-padding="true"
      :show-close-button="true"
      @close-button-click="handleClose"
    >
      <template #body>
        <h2 class="tw-mb-2 tw-text-2xl tw-font-medium tw-text-center text-regular-color">
          About Live Snow Data
        </h2>
        <p class="tw-mb-2 text-regular-color">
          {{ message }}
        </p>
        <footer class="tw-mb-2 tw-text-center">
          <a
            class="link-color-brand hover:tw-underline"
            :href="readMoreLink"
            rel="noopenener noreferrer"
            target="_blank"
          >
            Read More about Live Snow
          </a>
        </footer>
      </template>
    </Card>
  </Dialog>
</template>

<script>
export default {
  name: 'AboutWeatherStationsDialog',

  props: {
    message: {
      type: String,
      required: true,
    },
    readMoreLink: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close'],

  methods: {
    handleClose(returnValue) {
      this.$emit('close', returnValue);
    },
  },
};
</script>
